var _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSessionCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.7648,
    cy: 11.7057,
    r: 11.2941,
    fill: "#F4F6F7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.7652,
    cy: 11.7057,
    r: 5.64706,
    fill: "#D0D8DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionCount);
export default __webpack_public_path__ + "static/media/SessionCount.1eb2ce3be6e5005a2692db680f811ba4.svg";
export { ForwardRef as ReactComponent };